{
	"clientInvoices": {
		"title": "Invoices from {{clientName}}",
		"submitButton": "Issue notes",
		"name": "Consumers",
		"issuedAt": "Date and time",
		"links": "Links",
		"loading": "Loading...",
		"noInvoices": "There are no issued notes to display",
		"somethingWrong": "Something went wrong",
		"updatePage": "Please refresh the page and try again",
		"openPdf": "Open PDF",
		"openCoupon": "Open Coupon",
		"onSubmitEmailForm": "Send invoices by email",
		"email": "Email",
		"send": "Send"
	},
	"clientTransactions": {
		"title": "Extract from client'{{clientName}}'",
		"date": "Hour",
		"product": "Products",
		"sellerName": "Seller",
		"buyers": "Buyers",
		"refunded": "Refunded?"
	}
}
